import { z } from "zod";
import { IAreasQueryParams } from "./StructureAreas.models";

export const FilterBarSchema = z.object({
  search: z.string().optional(),
  sortType: z.enum(["asc", "desc"]),
});

export const FilterBarDefaultValues: IAreasQueryParams = {
  search: "",
  sortType: "asc",
  structureId: "123",
};
